/**
 * init class API
 * @param opt
 * @returns {KensoftApi}
 * @constructor
 */
function KensoftApi(opt) {
  if (!(this instanceof KensoftApi)) {
    return new KensoftApi(opt);
  }
  opt = opt || {};
  this.classVersion = '1.0.0';
  this._setDefaultsOptions(opt);
}

/**
 * Default option
 * @param opt
 * @private
 */
KensoftApi.prototype._setDefaultsOptions = async function (opt) {
  this.url = opt.url;
  this.logo = opt.logo;
  this.tags = null;
  this.Categories = null;
  this.brands = null;
  this.questioncategories = null;
  //console.log('init api');

  // this.getTags();
  // this.getCategories();
};
KensoftApi.prototype.getSlider = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getSlider?' + requestUrl;

  // console.log('category url: ', requestUrl);
  console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getServices = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getServices?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getProducts = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getProducts?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getIso = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getIso?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getAboutProducts = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getAboutProducts?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.EmailForm = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/EmailForm?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.getChooseUs = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getChooseUs?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getFProduct = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/getFProduct?' + requestUrl;

  //console.log('category url: ', requestUrl);
  //console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.getOurProduct = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  requestUrl = this.url + '/services/getOurProduct?' + requestUrl;

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.updateUserPushToken = function (data, postdata, callback) {
  var requestUrl = this.url + '/services/UserPushTokenUpdate?';
  requestUrl += this.join(data, '&');
  //console.log(requestUrl);
  return this._request(requestUrl, callback);
};
KensoftApi.prototype.listingReviewsGet = function (data, callback) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  }

  var requestUrl = this.url + '/services/ListingFeedbackGet?' + requestUrl;
  //alert(requestUrl);
  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.listingFeedbackSave = function (data, userid) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  }

  var requestUrl = this.url + '/services/ListingFeedbackSave?' + requestUrl;

  // console.log('category url: ', requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.getHomePage = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/mainpage?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.searchSuggestions = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/searchsuggestions?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.barcodeSearch = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/barcodesearch?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getCategoryProducts = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/CategoryProductsGet?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getAddress = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/addresses?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.addAddress = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/UserAddressSave/?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.loginLyv = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  }

  var requestUrl = this.url + '/services/login?' + requestUrl;

  //console.log('category url: ', requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.getCategoryBrandProducts = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/CategoryProductsGet?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
/**
 * Get list of Categories
 */
KensoftApi.prototype.getCategories = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/Categories?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    this.Categories = data;
    return data;
  });
};
KensoftApi.prototype.getRelatedProducts = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/CategoryProductsGet?' + requestUrl;

  // console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    this.Categories = data;
    return data;
  });
};

KensoftApi.prototype.getBrands = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/brandsget?' + requestUrl;

  // console.log('category url: ', requestUrl);

  if (this.brands !== null) {
    return this.brands;
  }
  return this._request(requestUrl).then(function (data) {
    this.brands = data;
    return data;
  });
};

KensoftApi.prototype.getQuestionCategories = function (data) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  } else {
    requestUrl = 'parent=0';
  }

  var requestUrl = this.url + '/services/questioncategoriesget?' + requestUrl;

  // console.log('category url: ', requestUrl);

  if (this.questioncategories !== null) {
    return this.questioncategories;
  }
  return this._request(requestUrl).then(function (data) {
    this.questioncategories = data;
    return data;
  });
};

/**
 * Request to the server,
 * You fixed: https://gist.github.com/pranavrajs/66bccee3f8ba100742a1273db6f587af
 * @param url
 * @param callback
 * @private
 */
KensoftApi.prototype._request = function (url, callback) {
  var self = this;

  return fetch(url, {
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      // "Content-Type": "application/json",
    },
  })
    .then((response) => response.text()) // Convert to text instead of res.json()
    .then((text) => {
      return text;
    })
    .then((response) => JSON.parse(response))

    .catch((error, data) => {
      // //console.log('1=error network -', error, data);
    })
    .then((responseData) => {
      if (typeof callback == 'function') {
        callback(responseData);
      }
      ////console.log('request result from ' + url, responseData);
      return responseData;
    })
    .catch((error) => {
      // //console.log('2=error network -- ', error.message);
    });
};
KensoftApi.prototype._requestPost = function (url, data, callback) {
  var self = this;
  var params = {
    mode: 'cors',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      //   "Content-Type": "application/json"
    },
    // credentials: 'same-origin',
    // mode: 'same-origin',
    body: JSON.stringify(data),
  };
  console.log(url);
  console.log(JSON.stringify(data));
  return fetch(url, params)
    .then((response) => response.text()) // Convert to text instead of res.json()
    .then((text) => {
      return text;
    })
    .then((response) => JSON.parse(response))

    .catch((error, data) => {
      // alert(
      //   Languages.SomethingWentWrong + "\n" + "1=error network -" + error,
      //   data
      // );
    })
    .then((responseData) => {
      if (typeof callback == 'function') {
        callback(responseData);
      }
      return responseData;
    })
    .catch((error) => {
      // alert(
      //   Languages.SomethingWentWrong + "\n" + "error network" + error.message
      // );
    });
};

/**
 * Get default logo from Wordpress
 * @returns {logo|{height, width, marginLeft}|{marginBottom, marginTop, height, width, alignSelf}|boolean|{width, height, resizeMode, marginTop, marginBottom, marginLeft}|{resizeMode, height, marginTop, marginRight, marginBottom, marginLeft}|*}
 */
KensoftApi.prototype.getLogo = function () {
  return this.logo;
};

KensoftApi.prototype.join = function (obj, separator) {
  var arr = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      arr.push(key + '=' + obj[key]);
    }
  }
  return arr.join(separator);
};

/**
 * Get posts listing
 * @param data
 * @param callback
 */
KensoftApi.prototype.getStickyPost = function () {
  //var requestUrl = this.url + '/wp-json/wp/v2/posts/?_embed&sticky=true';
  // console.log('get sticky Posts', requestUrl);
  return this.getPosts({ id: '101' });
};

/**
 * Get posts listing
 * @param data
 * @param callback
 */
KensoftApi.prototype.getPosts = function (data, callback, noEmbed) {
  var embedText = '_embed';
  if (typeof noEmbed !== 'undefined') {
    embedText = '';
  }

  var requestUrl = this.url + '/services/articles/?' + embedText;
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  } else {
    data = { page: 1 };
    requestUrl += '&' + this.join(data, '&');
  }
  return this._request(requestUrl, callback);
};

KensoftApi.prototype.getQuestions = function (data, callback, noEmbed) {
  var embedText = '_embed';
  if (typeof noEmbed !== 'undefined') {
    embedText = '';
  }

  var requestUrl = this.url + '/services/questions/?' + embedText;
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  } else {
    data = { page: 1 };
    requestUrl += '&' + this.join(data, '&');
  }
  return this._request(requestUrl, callback);
};

KensoftApi.prototype.getPages = function (data, callback) {
  var requestUrl = this.url + '/wp-json/wp/v2/pages/' + data.id;
  if (data) {
    // requestUrl += '&' + this.join(data, '&');
  }
  // console.log('get Pages', requestUrl);
  return this._request(requestUrl, callback);
};

KensoftApi.prototype.getNonceRegister = function () {
  const requestUrl =
    this.url + '/api/get_nonce/?controller=user&method=register';

  // console.log('get nonce', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.getNonce = function () {
  const requestUrl =
    this.url + '/api/get_nonce/?controller=user&method=generate_auth_cookie';

  return this._request(requestUrl).then(function (data) {
    // console.log(data);
    return data;
  });
};

KensoftApi.prototype.request = function (requestUrl) {
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.generateAuthCookie = async function ($email, $password) {
  const data = await this.getNonce();
  if (typeof data.status != 'undefined' && data.status == 'ok') {
    const nonce = data.nonce;
    const requestUrl =
      this.url +
      '/api/user/generate_auth_cookie/?insecure=cool&nonce=' +
      nonce +
      '&username=' +
      $email +
      '&password=' +
      $password;

    // console.log('user login', requestUrl);

    return this._request(requestUrl);
  }
};
KensoftApi.prototype.fetchUserFavorites = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserListListingsGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  } else {
    data = { page: 1 };
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.toggleFavorites = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserListListingToggle?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.listingDelete = function (data, postData, callback) {
  var requestUrl = this.url + '/services/listingdelete?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.register = async function ($email, $password, $name) {
  const data = await this.getNonceRegister();

  if (typeof data.status != 'undefined' && data.status == 'ok') {
    const nonce = data.nonce;

    const requestUrl =
      this.url +
      '/api/user/register/?insecure=cool&nonce=' +
      nonce +
      '&email=' +
      $email +
      '&username=' +
      $email +
      '&display_name=' +
      $name +
      '&password=' +
      $password;

    // console.log('user register', requestUrl);

    return this._request(requestUrl);
  }
};

KensoftApi.prototype.completeRegistration = function (
  data,
  postData,
  callback
) {
  var requestUrl = this.url + '/services/usermembershipsave?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  console.log(JSON.stringify(postData));

  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.forgotPassword = function (data, postData, callback) {
  var requestUrl = this.url + '/services/RequestReset?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }

  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.verifyOTP = function (data, postData, callback) {
  var requestUrl = this.url + '/services/userverifyotp?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.verifyTempOTP = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserVerifyTempOTP?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.verifyCODE = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ConfirmResetCode?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.updateUserPushToken = function (data, postdata, callback) {
  var requestUrl = this.url + '/services/UserPushTokenUpdate?';
  requestUrl += this.join(data, '&');
  //console.log(requestUrl);
  return this._request(requestUrl, callback);
};

KensoftApi.prototype.getCommunication = function (data, callback) {
  var requestUrl = this.url + '/services/MessagingGetCommunication?';
  requestUrl += this.join(data, '&');

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.SendMessage = function (data, callback) {
  var requestUrl = this.url + '/services/MessagingSend?';
  requestUrl += this.join(data, '&');

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.getMessageSessions = function (data, callback) {
  var requestUrl = this.url + '/services/MessagingGetSessions?';
  requestUrl += this.join(data, '&');
  console.log(requestUrl);
  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.SetUserToken = function (data, callback) {
  var requestUrl = this.url + '/services/SetUserToken?';
  requestUrl += this.join(data, '&');

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.GetFeatureRules = function (data, callback) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  }

  var requestUrl = this.url + '/services/GetFeatureRules?' + requestUrl;
  //alert(requestUrl);
  //console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};

KensoftApi.prototype.GetVenueDescriptions = function (data, callback) {
  var requestUrl = '';
  if (data) {
    requestUrl = this.join(data, '&');
  }

  var requestUrl = this.url + '/services/GetVenueDescriptions?' + requestUrl;
  //alert(requestUrl);
  //console.log('category url: ', requestUrl);

  return this._request(requestUrl).then(function (data) {
    return data;
  });
};
KensoftApi.prototype.VenueDoAdd = function (data, postData, callback) {
  var requestUrl = this.url + '/services/VenueDoAdd';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.VenueEditGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/VenueEditGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ServiceEditGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ServiceEditGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ServiceDoAdd = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ServiceDoAdd';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.ReviewsGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ReviewsGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.ReviewSave = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ReviewSave';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.MenuDoAdd = function (data, postData, callback) {
  var requestUrl = this.url + '/services/MenuDoAdd';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }

  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ResourceDoAdd = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ResourceDoAdd';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.PolicyDoAdd = function (data, postData, callback) {
  var requestUrl = this.url + '/services/PolicyDoAdd';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.RulesDoAdd = function (data, postData, callback) {
  var requestUrl = this.url + '/services/RulesDoAdd';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  console.log(postData);
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.UserVenues = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserVenues';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.Register = function (data, postData, callback) {
  var requestUrl = this.url + '/services/Register';

  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.Login = function (data, postData, callback) {
  var requestUrl = this.url + '/services/Login';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.UpdateUserInfo = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UpdateUserInfo';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.UpdateBookItem = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UpdateBookItem';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.BookEventPayment = function (data, postData, callback) {
  var requestUrl = this.url + '/services/BookEventPayment';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};

KensoftApi.prototype.VenuesGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/VenuesGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }

  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.VenueGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/VenueGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  console.log(requestUrl);
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ServiceGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ServiceGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  console.log(requestUrl);
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.GetRelated = function (data, postData, callback) {
  var requestUrl = this.url + '/services/GetRelated';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  console.log(requestUrl);
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ServicesGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ServicesGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }

  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.CategoriesGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/CategoriesGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.PropertiesGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/PropertiesGet';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.HomePage = function (data, postData, callback) {
  var requestUrl = this.url + '/services/HomePage';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.AreasGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/AreasGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ServiceCategoriesGet = function (
  data,
  postData,
  callback
) {
  var requestUrl = this.url + '/services/ServiceCategoriesGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.CountriesGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/CountriesGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.CitiesGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/CitiesGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  console.log(requestUrl);
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.AreasGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/AreasGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.BookItem = function (data, postData, callback) {
  var requestUrl = this.url + '/services/BookItem?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ResendActivationEmail = function (
  data,
  postData,
  callback
) {
  var requestUrl = this.url + '/services/ResendActivationEmail?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ActiveAccount = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ActiveAccount?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.UserGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.UserGetByProvider = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserGetByProvider?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.SendInquiry = function (data, postData, callback) {
  var requestUrl = this.url + '/services/SendInquiry?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.BlogsGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/BlogsGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.BlogDetailsGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/BlogDetailsGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.EventGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/EventGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.BookingUpdateStatus = function (data, postData, callback) {
  var requestUrl = this.url + '/services/BookingUpdateStatus?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.OwnerEventsGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/OwnerEventsGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.VenueBookmark = function (data, postData, callback) {
  var requestUrl = this.url + '/services/VenueBookmark?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.UserBookmarksGet = function (data, postData, callback) {
  var requestUrl = this.url + '/services/UserBookmarksGet?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
KensoftApi.prototype.ResourceDoRemove = function (data, postData, callback) {
  var requestUrl = this.url + '/services/ResourceDoRemove?';
  if (data) {
    requestUrl += '&' + this.join(data, '&');
  }
  return this._requestPost(requestUrl, postData, callback);
};
var ks = new KensoftApi({
  url: 'https://www.riyadhgrp.com',
  logo: '',
});

export default ks;
